import React, { useState, useEffect, useRef } from 'react';
import { Modal, TextField, BlockStack, Text, Icon, ResourceList, ResourceItem } from '@shopify/polaris';
import { SearchIcon } from '@shopify/polaris-icons';

import { FetchCustom } from './FetchCustom';
import { useHostNavigate } from "../hooks";

export function SegmentPickerCustom(props) {
    const navigate = useHostNavigate();
    const fetch = FetchCustom();

    const [loading, setLoading] = useState(false);
    const [list, setList] = useState({ items: [], pageInfo: {} });
    const [selectedItems, setSelectedItems] = useState(props.selectedSegments ? props.selectedSegments : []);
    const [redirectUrl, setRedirectUrl] = useState('');

    const typingTimer = useRef();

    const load = async (startCursor, endCursor, query) => {
        setLoading(true);

        const data = await fetch('api/home/segments', { startCursor: startCursor, endCursor: endCursor, query: query });
        if (data.redirectUrl) {
            setRedirectUrl(data.redirectUrl);
        }
        else {
            setList(data);
            setLoading(false);
        }
    };

    useEffect(() => {
        if (props.open) {
            load(null, null, props.initialQuery);
        }
        // eslint-disable-next-line
    }, [props.open]);

    useEffect(() => {
        if (redirectUrl) {
            navigate(redirectUrl);
        }
    }, [redirectUrl, navigate]);

    return (
        <Modal
            title={props.editing ? "Edit segments" : "Add segments"}
            open={props.open}
            limitHeight={true}
            onClose={() => { props.handleSegmentPicker('open', false); }}
            primaryAction={{
                content: props.editing ? "Done" : "Add",
                onAction: () => {
                    let ids = props.initialSelectionIds.map(p => p.replace('segment_', '')).join();
                    props.handleChange('segments', ids);
                    props.handleChange('selectedSegments', selectedItems);
                    props.handleChange('customers', null);
                    props.handleChange('selectedCustomers', null);
                    props.handleChange('customerTags', null);
                    props.handleChange('selectedCustomerTags', null);
                    props.handleError('customerType', !ids);
                    props.handleSegmentPicker('open', false);
                }
            }}
            secondaryActions={[
                {
                    content: 'Cancel',
                    onAction: () => { props.handleSegmentPicker('open', false); }
                },
            ]}
        >
            <div className="segment-picker">
                <div className="modal-sticky-bar">
                    <Modal.Section>
                        <BlockStack gap="300">
                            <div><Text as="span" tone="subdued">You can create a new segment from the</Text> <a href={props.user.shopifyAdminUrl + "/customers/segments/new"} target="_blank" rel="noreferrer" className="Polaris-Link">Segments Page</a></div>
                            <TextField
                                value={props.initialQuery}
                                focused={true}
                                placeholder={'Search customer segments'}
                                prefix={<Icon source={SearchIcon} tone="subdued" />}
                                onChange={(newValue) => {
                                    props.handleSegmentPicker('initialQuery', newValue);
                                    clearTimeout(typingTimer.current);
                                    typingTimer.current = setTimeout(function () {
                                        load(null, null, newValue);
                                    }, 400);
                                }}
                            />
                        </BlockStack>
                    </Modal.Section>
                </div>
                <ResourceList
                    items={list.items}
                    selectedItems={props.initialSelectionIds}
                    loading={loading}
                    emptyState={<Modal.Section>{`No results found${props.initialQuery ? ' for "' + props.initialQuery + '"' : ''}`}</Modal.Section>}
                    onSelectionChange={(newValue) => {
                        props.handleSegmentPicker('initialSelectionIds', newValue);

                        let ids = newValue.map(p => parseFloat(p.replace('segment_', '')));
                        let sItems = selectedItems.filter(p => ids.indexOf(p.id) > -1);

                        ids.forEach(id => {
                            if (!sItems.filter(p => p.id === id).length) {
                                sItems.push(list.items.filter(p => p.id === id)[0]);
                            }
                        });

                        setSelectedItems(sItems);
                    }}
                    pagination={list.pageInfo.hasPreviousPage || list.pageInfo.hasNextPage ? {
                        hasPrevious: list.pageInfo.hasPreviousPage,
                        hasNext: list.pageInfo.hasNextPage,
                        onPrevious: () => {
                            load(list.pageInfo.startCursor, null, null);
                        },
                        onNext: () => {
                            load(null, list.pageInfo.endCursor, null);
                        },
                    } : null}
                    renderItem={(item) => {
                        return (
                            <ResourceItem
                                verticalAlignment="center"
                                id={"segment_" + item.id}
                                key={item.id}
                                onClick={() => {
                                    let el = document.querySelector('.segment-picker')?.querySelector(`.Polaris-Box#segment_${item.id}`)?.querySelector('.Polaris-Checkbox__Input');
                                    if (el) {
                                        el.click();
                                    }
                                }}
                            >
                                <Text>{item.name}</Text>
                            </ResourceItem>
                        );
                    }}
                    selectable={true}
                    showHeader={false}
                />
            </div>
        </Modal>
    );
}